/* eslint-disable no-console */

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("./sw.js")
}
